import { datadogLogs } from '@datadog/browser-logs'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'

datadogLogs.init({
  clientToken: 'pubd28bf1aad2fa553f3daa90000617d30f',
  site: 'us3.datadoghq.com',
  forwardErrorsToLogs: true,
  sessionSampleRate: 100,
  service: 'auth-ui',
  env: 'production',
  // See "Scrub sensitive data from your Browser logs"
  // https://docs.datadoghq.com/logs/log_collection/javascript/#scrub-sensitive-data-from-your-browser-logs
  beforeSend: (log, _) => {
    log.view.url = log.view.url.replace(/token=[^&]*/, "token=REDACTED")
    if (log.view.url_details) {
      const params = log.view.url_details;
      if (params.hash) {
        params.hash = "REDACTED"
      }
    }
    return true;
  }
});

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
